import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  margin-top: 0;
  transition: all 0.3s ease;
`;

export const LevelsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const LevelCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
  align-self: start;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const LevelCardContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
`;

export const LevelTitle = styled.div`
  margin: 0;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LevelDetailsGrid = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const OrderBadge = styled.div`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  background-color: ${COLORS.BACKGROUND_LIGHT};
  color: ${COLORS.PRIMARY};
  font-size: 14px;
  font-weight: 500;
`;

export const ItalicText = styled.span`
  color: #94A3B8;
  font-style: italic;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`; 